// pages/ProjectSection.js
import React from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { projectsData } from "../data/projectsData";
import "../styles/projectDetail.css";

export default function ProjectSection() {
  const { sectionId } = useParams();

  // Find by id (or slug if you add one later)
  const project = projectsData.find(p => (p.id || p.slug) === sectionId) || null;

  if (!project) {
    return (
      <div className="project-detail">
        <Navbar />
        <div className="section-inner" style={{ padding: "4rem 0" }}>
          <h2>Project not found</h2>
          <Link to="/Projects" className="btn-secondary">← Back to Projects</Link>
        </div>
      </div>
    );
  }

  const { title = "" } = project;
  const a = project.a || {};
  const b = project.b || {};
  const c = project.c || {};
  const duringImages = Array.isArray(c.images) ? c.images : [];
  const steps = Array.isArray(c.list) ? c.list : [];

  // Pick hero from "b" (finished); if missing, fall back safely
  const heroImg = b.image || a.image || duringImages[0] || null;
  const heroAlt = b.caption || title || "Project";

  return (
    <div className="project-detail">
      <Navbar />

      {/* HERO (Finished) */}
      {heroImg && (
        <header className="project-detail-hero">
          <img src={heroImg} alt={heroAlt} />
          <div className="pd-hero_title section-inner">
            <Link to="/Projects" className="pd-back">← Back to Projects</Link>
            <h1>{title}</h1>
          </div>
        </header>
      )}

      <main className="project-detail-body section-inner">
        {/* Finished meta (caption/CTA) */}
        {(b.caption || b.cta) && (
          <section className="pd-row pd-row--finishedmeta">
            <h3 className="pd-label">{b.label || "Finished"}</h3>
            {b.caption && <p>{b.caption}</p>}
            {b.cta?.to && b.cta?.label && (
              <div className="pd-cta">
                <Link to={b.cta.to} className="btn-primary">{b.cta.label}</Link>
              </div>
            )}
          </section>
        )}

        {/* BEFORE */}
        {(a.image || a.body) && (
          <section className="pd-row">
            <h3 className="pd-label">{a.label || "Before"}</h3>
            {a.image && (
              <figure className="story-figure">
                <img
                  src={a.image}
                  alt={a.title ? `Before — ${a.title}` : `Before — ${title}`}
                />
                {(a.title || a.caption) && (
                  <figcaption>{a.title || a.caption}</figcaption>
                )}
              </figure>
            )}
            {a.body && <p>{a.body}</p>}
          </section>
        )}

        {/* DURING */}
        {(duringImages.length > 0 || c.body || steps.length > 0) && (
          <section className="pd-row">
            <h3 className="pd-label">{c.label || "During"}</h3>

            {duringImages.length > 0 && (
              <div className="pd-during">
                {duringImages.map((src, i) => (
                  <figure key={i} className="story-figure">
                    <img src={src} alt={`During ${i + 1}`} />
                  </figure>
                ))}
              </div>
            )}

            {c.body && <p>{c.body}</p>}

            {steps.length > 0 && (
              <ul className="pd-steps">
                {steps.map((s, i) => <li key={i}>{s}</li>)}
              </ul>
            )}
          </section>
        )}
      </main>
    </div>
  );
}
